import React, { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { Switch } from 'react-router-dom/cjs/react-router-dom.min'
import { Card, Tabs } from 'antd'
import { get, groupBy, map, values } from 'lodash'

import { PermissionRoute } from '../../../common/components/routes'
import { PERMISSIONS } from '../../../common/constants'
import { useFilterOnPermission } from '../../../common/hooks'

import { REPORT_ROUTES } from '../../constants'
import { useLastPathnameSegment } from '../../hooks'
import { MetadataNodesReportSection, UserReportSection } from '../sections'

const ReportsPage = () => {
  const history = useHistory()
  const currentTab = useLastPathnameSegment()

  const reportRoutesGroupedByKey = useMemo(
    () => groupBy(values(REPORT_ROUTES), 'key'),
    [],
  )

  const handleChangeTab = useCallback(
    tabKey => history.push(get(reportRoutesGroupedByKey, `${tabKey}[0].link`)),
    [history, reportRoutesGroupedByKey],
  )

  const tasksTabsOnPermissions = useFilterOnPermission(REPORT_ROUTES)

  return (
    <Card>
      <Tabs
        type="card"
        defaultActiveKey={currentTab}
        onChange={handleChangeTab}
      >
        {map(tasksTabsOnPermissions, tab => (
          <Tabs.TabPane tab={tab.name} key={tab.key} />
        ))}
      </Tabs>

      <Switch>
        <PermissionRoute
          permissions={PERMISSIONS.REPORT.GET_FOR_USERS}
          exact
          path={REPORT_ROUTES.USERS.link}
          component={UserReportSection}
        />

        <PermissionRoute
          permissions={PERMISSIONS.REPORT.METADATA_NODES}
          exact
          path={REPORT_ROUTES.METADATA_NODES.link}
          component={MetadataNodesReportSection}
        />
      </Switch>
    </Card>
  )
}

export default ReportsPage
